The upper limit of webhook requests to return from the end of the list.

Excess webhook requests will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
